module.exports = __webpack_public_path__ + "img/maintenance.9132d686.svg";